function arrayCompact(arr, all) {
    return arr.filter((el) => {
        return el || (!all && el != null);
    });
}
Array.prototype.compact = function () {
    return arrayCompact(this, false);
};
function arrayUnique(arr) {
    return arr.filter((v, i) => arr.indexOf(v) === i);
}
Array.prototype.unique = function () {
    return arrayUnique(this);
};
const TRIM_CHARS = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF';
const TRUNC_REG = RegExp(`(?=[${TRIM_CHARS}])`);
function reverseString(str) {
    return str
        .split('')
        .reverse()
        .join('');
}
function truncateOnWord(str, limit, fromLeft = false) {
    if (fromLeft) {
        return reverseString(truncateOnWord(reverseString(str), limit));
    }
    const words = str.split(TRUNC_REG);
    let count = 0;
    return words
        .filter(word => {
        count += word.length;
        return count <= limit;
    })
        .join('');
}
function truncateString(str, length, from, ellipsis = '…', split = false) {
    let str1;
    let str2;
    let len1;
    let len2;
    if (str.length <= length) {
        return str.toString();
    }
    switch (from) {
        case 'left':
            str2 = split
                ? truncateOnWord(str, length, true)
                : str.slice(str.length - length);
            return ellipsis + str2;
        case 'middle':
            len1 = Math.ceil(length / 2);
            len2 = Math.floor(length / 2);
            str1 = split ? truncateOnWord(str, len1) : str.slice(0, len1);
            str2 = split
                ? truncateOnWord(str, len2, true)
                : str.slice(str.length - len2);
            return str1 + ellipsis + str2;
        default:
            str1 = split ? truncateOnWord(str, length) : str.slice(0, length);
            return str1 + ellipsis;
    }
}
export function truncate(str, length, from, ellipsis) {
    return truncateString(str, length, from, ellipsis);
}
//# sourceMappingURL=string.js.map